import { Auth } from 'aws-amplify';

export class Authentication {
  public static get email() {
    return Auth.currentSession().then((session) => session.getIdToken().payload.email as string).catch((err) => '');
  }
  public static get id() {
    return Auth.currentSession().then((session) => session.getIdToken().payload.sub);
  }
  public static get idToken() {
    return Auth.currentSession().then((session) => session.getIdToken().getJwtToken()).catch((err) => '');
  }
  public static get isAuthenticated() {
    return Auth.currentSession().then((data) => data.isValid()).catch((err) => false);
  }

  public static signUp = async (username: string, password: string) => Auth.signUp(username, password);
  public static confirmSignUp = async (username: string, code: string) => Auth.confirmSignUp(username, code);
  public static resendSignUp = async (username: string) => Auth.resendSignUp(username);
  public static signIn = async (username: string, password: string) => Auth.signIn(username, password);
  public static signOut = async () => Auth.signOut();
}

export const checkAuthentication = (next) => {
  Authentication.isAuthenticated.then((isAuthenticated) => {
    if (isAuthenticated) {
      next();
    } else {
      next({path: '/signin'});
    }
  });
};
